import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Catering_Management/AddonService/Add_AddonService';
import Edit from '../../../../modal/Settings/Catering_Management/AddonService/Edit_AddonService';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddOnService = () => {
    const tableRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [rows, setRows] = useState([]);
    const [editData, setEditData] = useState(null);
    
        const [page, setPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [searchTerm, setSearchTerm] = useState('');
        const [perPage, setPerPage] = useState(25);
        const [total_entries, setTotslEntries] = useState(0);
        const [datas, setData] = useState([]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const unitOptions = [
    { value: "1", label: "gms" },
    { value: "2", label: "Kg's" },
    { value: "3", label: "Ltr's" },
    { value: "4", label: "ton's" },
    { value: "5", label: "No's" },
    { value: "6", label: "cm" },
    ];

    const handleModalToggle = () => {
        setModalType("Add");
        setEditData(null);
        setOpen(true);
    };

    const handleModalToggle_Edit = (data) => {
        setModalType("Edit");
        setEditData(data);
        setOpen(true);
    };

    const fetchList = async () => {
        try {
            const res = await axios.get(`${baseURL}/addonservice/list`);
            setRows(res.data || []);
        } catch (err) {
            console.error('Failed to fetch data:', err);
        }
    };


    const handleStatusToggle = async (item) => {
        const newStatus = item.status === 0 ? 1 : 0; 
        try {
            await axios.put(`${baseURL}/addonservice/update_status/${item.sno}`, { status: newStatus });
        
            setRows((prevRows) =>
                prevRows.map((row) =>
                    row.sno === item.sno ? { ...row, status: newStatus } : row
                )
            );
            toast.success('Status updated successfully!');
        } catch (error) {
            console.error('Error updating status:', error);
            window.alert('Failed to update status. Please try again.');
        }
    };

    const DeleteModal = (item) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Add-On Service
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Man Power</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <!-- svg content omitted for brevity -->
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${baseURL}/addonservice/service_delete/${item.sno}`);
                    toast.success('Deleted successfully!');
                    fetchList();
                } catch (err) {
                    swal.fire('Error', 'Delete failed', 'error');
                }
            } else {
                swal.fire({
                    title: 'Delete Cancelled',
                    text: item.service,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    customClass: { confirmButton: 'btn btn-sm btn-primary' },
                });
            }
        });
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleUpdated = () => {
        fetchList();
    };

    useEffect(() => {
        console.log('Initializing DataTable with rows:', rows.length);

        if (tableRef.current && rows.length) {
            const table = $(tableRef.current);

            setTimeout(() => {
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                table.DataTable({
                    responsive: true,
                    ordering: false,
                    language: { lengthMenu: "Show _MENU_" },
                    dom:
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }, 0);
        }
    }, [rows]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Add On Service </h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Catering Management</li>
                    </ol>
                </div>
                <Button className="btn btn-primary btn-sm" onClick={handleModalToggle}>
                    <span className="me-2"><i className="fa-solid fa-plus fs-8"></i></span>
                    <span>Add on Service</span>
                </Button>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onCreated={handleUpdated} />
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} editData={editData} onUpdated={handleUpdated} />
                )}
            </div>

            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); 
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                </div>
                <table
                    id="kt_datatable_responsive_approved"
                    className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                >
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-50px text-start'>S.No</th>
                            <th className='min-w-150px'>Service</th>
                            <th className='min-w-80px'>Quantity Units</th>
                            <th className='min-w-100px'>Cost (per Unit)</th>
                            <th className='min-w-100px'>Status</th>
                            <th className='min-w-100px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {rows.map((item, idx) => (
                            <tr key={item.sno}>
                                <td className='text-start'>
                                    <label className='text-black font-w400 fs-7'>{idx + 1}</label>
                                </td>
                                <td>
                                    <label className='text-black font-w400 fs-7'>{item.service}</label>
                                    <OverlayTrigger overlay={
                                        <Tooltip className='toltip-popover'>
                                            <span className='fs-8 text-white fw-semibold'>{item.description || 'No description'}</span>
                                        </Tooltip>
                                    }>
                                        <i className="fa-solid fa-circle-info text-black fs-7 ms-2"></i>
                                    </OverlayTrigger>
                                </td>
                                <td><label className='text-black font-w400 fs-7'>1 {unitOptions.find(u => u.value === String(item.quantity))?.label || ""}</label></td>
                                <td><label className='text-black font-w400 fs-7'>₹ {item.cost_per_unit}</label></td>
                                <td>
                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            role="switch"
                                            checked={item.status === 0}
                                            onChange={() => handleStatusToggle(item)}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <span className="text-end">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={
                                            <Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>
                                        }>
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(item)}>
                                                <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                            </Button>
                                        </OverlayTrigger>
                                        {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={
                                            <Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>
                                        }>
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => DeleteModal(item)}>
                                                <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                            </Button>
                                        </OverlayTrigger> */}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {rows.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + rows.length} of {rows.length} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        {/* <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav> */}
                        
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                    Previous
                                </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                    1
                                </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                .map(p => (
                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                        {p}
                                    </button>
                                    </li>
                                ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                    {totalPages}
                                    </button>
                                </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                    Next
                                </button>
                                </li>
                            </ul>
                        </nav>

                </div>
                
            </div>
        </>
    );
};

export default AddOnService;
